import { render } from "./2.Discover.vue?vue&type=template&id=7e1cd5e2&scoped=true"
import script from "./2.Discover.vue?vue&type=script&lang=js"
export * from "./2.Discover.vue?vue&type=script&lang=js"

import "./2.Discover.vue?vue&type=style&index=0&id=7e1cd5e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1cd5e2"]])

export default __exports__